import type { ReactNode } from "react";

/**
 * Pins `cornerNumber` inside a triangle on the panel's top-left corner.
 * Renders the panel untouched when there is no number.
 */
export function PanelCornerNumber_({
  cornerNumber,
  children,
}: {
  cornerNumber: number | undefined;
  children: ReactNode;
}) {
  if (cornerNumber === undefined) {
    return children;
  }
  return (
    <div className="relative">
      {children}
      {/* After the panel so it paints over its corner without a z-index. It
          covers the panel's border rather than sitting inside it: on a zoomed
          screen a shape 1px in rounds to a different pixel than the border
          and leaves a light line between them. */}
      <div
        data-testid="panel-corner-number"
        className="absolute top-0 left-0 h-14 w-14"
      >
        <svg
          aria-hidden="true"
          viewBox="0 0 56 56"
          className="size-full fill-blue"
        >
          <path d="M0 0 H56 L0 56 Z" />
        </svg>
        <span className="absolute top-2 left-2.5 text-lg leading-none font-bold text-white">
          {cornerNumber}
        </span>
      </div>
    </div>
  );
}
